<template>
  <fieldset class="mb-3">
    <label class="mt-1 rounded-md capitalize">{{ label }}</label>
    <div class="mt-1">
      <select
        :value="modelValue"
        class="border px-1 border-gray-300 rounded-lg shadow-sm block w-full resize-none focus:ring-0 sm:text-sm jack-description"
        @input="updateValue"
      >
        <option value="">-- empty --</option>
        <option v-for="option in options" :value="option.id">
          {{ option.name }}
        </option>
      </select>
      <div v-if="error" class="mt-1 text-xs text-red-500" v-text="error"></div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "Select",
  mounted(){
    this.selected = this.value;
  },
  data(){
    return {
      selected : '',
    }
  },
  props:{
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Number, String],
      default: null,
    },
    error: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods:{
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value );
    },
  },
}
</script>

<style scoped>

</style>

